import { AxiosPromise } from 'axios';
import { http } from 'services';
import * as Types from './types';

export const list = (): AxiosPromise<Types.IApi.List.Response> => http.request.get('/api/notebooks');

export const single = (id: string): AxiosPromise<Types.IApi.Single.Response> =>
  http.request.get(`/api/notebooks/${encodeURIComponent(id)}`);

export const create = (data: Types.IApi.Create.Request): AxiosPromise<Types.IApi.Create.Response> =>
  http.request.post('/api/notebooks', data);

export const update = (id: string, data: Types.IApi.Update.Request): AxiosPromise<Types.IApi.Update.Response> =>
  http.request.patch(`/api/notebooks/${encodeURIComponent(id)}`, data);

/** Cascades server-side: the notebook's documents (files + vectors), their generated items and its chat go with it. */
export const remove = (id: string): AxiosPromise<{ success: boolean }> => http.request.delete(`/api/notebooks/${encodeURIComponent(id)}`);
